fragment ExpertDetailsListingFragment on expertDetailsListing_Entry {
  typeHandle
  experts {
    ... on expertsBlock_Entry {
      expert {
        ... on expert_Entry {
          title
          uri
        }
      }
      expertise
      quote
      image {
        url
        title
      }
      alt
    }
  }
}
